import { SearchType, TitleSearchType } from "@skinsoft/types"

export const SEARCH_TYPES: {[key: string]: SearchType} = {
    alias: 'alias',
    archive: 'archive',
    auditCampaign: 'auditProject',
    auditRecord: 'recolement',
    authority: 'authority',
    conditionReport: 'conditionReport',
    location: 'location',
    numericContainerItem: 'numericContainerItem',
    physicalAccessoryItem: 'physicalAccessoryItem',
    physicalContainerItem: 'physicalContainerItem',
    thesaurus: 'thesaurus',
    thesaurusTerm: 'ThesaurusTerm',
    physicalMuseumItem: 'physicalMuseumItem',
    specimen: 'specimen'
}

// search types for title search can be different from search types so we have to
// do the mapping
export const SEARCH_TITLE_TYPES: {[key: string]: TitleSearchType} = {
    [SEARCH_TYPES.alias]: "Alias",
    [SEARCH_TYPES.archive]: "Archive",
    [SEARCH_TYPES.location]: "Location",
    [SEARCH_TYPES.physicalContainerItem]: "PhysicalContainerItem",
    [SEARCH_TYPES.specimen]: "Specimen"
}